import styled from "styled-components";

export const SelectionIndicatorDiv = styled.div`
  background-color: var(--fd-colors-border-active) !important;
  height: 2px;
  position: absolute;
  top: 46px;
  transition: left 0.15s ease-in-out;
`;
